<header class="flex h-14 items-center gap-6 p-3" data-cy="app-header">
  <hlm-sheet side="left" class="md:hidden">
    <button
      hlmSheetTrigger
      hlmBtn
      variant="ghost"
      size="icon-sm"
      type="button"
      [attr.aria-label]="'menu.openNavigation' | translate"
      data-cy="app-header-menu-toggle">
      <ng-icon name="lucideMenu" />
    </button>
    <hlm-sheet-content *hlmSheetPortal="let ctx" class="w-72">
      <hlm-sheet-header>
        <h2 hlmSheetTitle>
          <app-logo />
        </h2>
      </hlm-sheet-header>
      <nav class="flex flex-col gap-1 px-4" [attr.aria-label]="'menu.mainNavigation' | translate">
        @for (menu of menus(); track menu.link) {
          <a
            hlmBtn
            variant="ghost"
            class="justify-start"
            [routerLink]="menu.link"
            routerLinkActive="bg-muted"
            ariaCurrentWhenActive="page"
            (click)="ctx.close()">
            <ng-icon [name]="menu.icon" />
            {{ menu.label | translate }}
          </a>
        }
      </nav>
    </hlm-sheet-content>
  </hlm-sheet>

  <a routerLink="/" class="flex items-center rounded-md" [attr.aria-label]="'app.title' | translate">
    <app-logo />
  </a>

  <nav hlmNavigationMenu class="hidden md:flex" [attr.aria-label]="'menu.mainNavigation' | translate" data-cy="main-navigation">
    <ul hlmNavigationMenuList class="gap-2">
      @for (menu of menus(); track menu.link) {
        <li hlmNavigationMenuItem>
          <a
            hlmNavigationMenuLink
            #link="routerLinkActive"
            [routerLink]="menu.link"
            routerLinkActive
            ariaCurrentWhenActive="page"
            [active]="link.isActive"
            class="data-active:border-border h-8 border border-transparent px-2 data-active:shadow-xs"
            [attr.data-cy]="'nav-' + menu.link">
            <ng-icon [name]="menu.icon" />
            {{ menu.label | translate }}
          </a>
        </li>
      }
    </ul>
  </nav>

  <div class="flex min-w-0 flex-1 items-center justify-end gap-3">
    <app-sap-token-button />
    <app-notifications-button />
    <app-user-menu />
    @if (canCreateParts()) {
      <app-add-part-menu />
    }
  </div>
</header>
